import React from 'react';

function SplashScreen() {
	return <div className='SplashScreen'>SplashScreen</div>;
}

export default SplashScreen;
